import { Button, Card, Checkbox, Flex, Skeleton, Typography } from 'antd';

import { CustomInputNumber } from '@app/components';

import { useDetachResponsibleFromLead } from '../hooks';

const { Text } = Typography;

export const DetachResponsibleFromLead = () => {
  const {
    minutes,
    setMinutes,
    never,
    setNever,
    handleSave,
    isLoading,
    isSaving,
  } = useDetachResponsibleFromLead();

  if (isLoading) {
    return <Skeleton active />;
  }

  return (
    <Card style={{ maxWidth: 400, width: '100%' }}>
      <Flex vertical gap={16}>
        <Text strong>Открепление ответственного от лида</Text>

        <Flex vertical gap={8}>
          <Text>Через сколько минут (максимум 10080, т.е. 7 суток)</Text>
          <CustomInputNumber
            inputValue={minutes}
            isAllowed={(floatValue: number) =>
              floatValue >= 1 && floatValue <= 10080
            }
            onSuccess={({ value }) => setMinutes(Number(value))}
            disabled={never}
          />
        </Flex>

        <Checkbox
          checked={never}
          onChange={(e) => {
            setNever(e.target.checked);
            if (e.target.checked) {
              setMinutes(null);
            }
          }}
        >
          Никогда
        </Checkbox>

        <Button
          type="primary"
          block
          onClick={handleSave}
          disabled={!never && !minutes}
          loading={isSaving}
        >
          Сохранить
        </Button>
      </Flex>
    </Card>
  );
};
